<nav class="h-[60px] shadow-[0_0px_4px_0_#00000040] flex items-center justify-between pl-4 pr-[50px]">
    <div class="flex items-center space-x-3">
        <a class="cursor-pointer" (click)="goBack()">
            <img class="w-6 h-6 hover:bg-[#f5f5f5] rounded" src="/images/back-arrow.svg" alt="back-arrow">
        </a>
        <p class="text-base text-[rgba(0,0,0,0.4)]">
           {{heading}}
        </p>
    </div>
    <div class="flex items-center space-x-5 relative">
        <!-- <div class="flex items-center bg-[rgba(0,0,0,0.04)] rounded-xl px-3 gap-2">
            <img src="/images/header-search.svg" alt="">
            <input type="text" class="py-2 focus:outline-none placeholder:text-[#00000033]  text-sm"
                placeholder="Search...">
        </div> -->
        <a class="cursor-pointer flex" routerLink="admin/communication">
            <img class="w-[20px]" src="/images/message.svg" alt="message">
            <span *ngIf="totalUnreadCount$ | async as count" class="absolute text-[8px] text-semibold text-[#FFFFFF] left-2 top-[-8px] bg-[#FF0000] w-4 h-4 rounded-full flex items-center justify-center">
                {{ count > 99 ? '99+' : count}}
            </span>
        </a>
        <a class="cursor-pointer flex" routerLink="admin/dashboard/all-notifications">
            <img class="w-[18px]" src="/images/notification.svg" alt="notification"><span *ngIf="notificationCount" class="absolute text-[8px] text-semibold text-[#FFFFFF] left-12 top-[-8px] bg-[#FF0000] w-4 h-4 rounded-full flex items-center justify-center">{{notificationCount > 99 ? '99+' : notificationCount}}</span> 
        </a>
        <!-- <a class="cursor-pointer">
            <img class="w-[24px] h-[24px]" src="/images/owner-icon.png" alt="owner-icon">
        </a> -->
    </div>
</nav>